module.exports = __webpack_public_path__ + "static/img/logo.37d66845.jpeg";